import { useState } from "react";
import {
  TableContainer,
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  Paper,
  TablePagination,
} from "@mui/material";
import { MdAdd, MdDelete } from "react-icons/md";
import { toast } from "react-toastify";
import { Link } from "react-router-dom";
import {
  useGetProServicesQuery,
  useRemoveProServiceMutation,
} from "../../features/api/proserviceApi";

const ProService = () => {
  const {
    data: proServc,
    error,
    isLoading,
  } = useGetProServicesQuery(null, {
    refetchOnMountOrArgChange: true,
  });

  const [removeProService] = useRemoveProServiceMutation();

  const handleDelete = async (id) => {
    const confirm = window.confirm("Are Your Sure?");
    if (confirm) {
      try {
        const result = await removeProService(id);

        if (result) {
          toast.success("Delete Success..!!!");
        }
      } catch (error) {
        console.log(error);
      }
    }
  };

  const [searchTerm, setSearchTerm] = useState("");

  const filterSearch = searchTerm
    ? proServc?.filter(
        (d) =>
          d?.job_no.toLowerCase().includes(searchTerm.toLocaleLowerCase()) ||
          d?.client.toLowerCase().includes(searchTerm.toLocaleLowerCase()) ||
          d?.model.toLowerCase().includes(searchTerm.toLocaleLowerCase())
      )
    : proServc;

  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(50);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  function formatDate(dateString) {
    const date = new Date(dateString);
    let day = date.getDate();
    let month = date.getMonth() + 1;
    let year = date.getFullYear();
    let getDate = day + "-" + month + "-" + year;
    return getDate;
  }

  return (
    <div>
      <div className="flex justify-between items-center px-12 my-6">
        <h1 className="text-xl font-bold">Product Service Center</h1>
        <div className="flex items-center gap-2">
          <Link
            to="/dashboard/product-service/create"
            className="text-white bg-blue-600 uppercase cursor-pointer flex items-center gap-1 px-2 py-1 rounded"
          >
            <span>
              <MdAdd className="text-xl" />
            </span>
            <span>New Entry</span>
          </Link>

          {/* <Link
            to="/dashboard/product-services-bill"
            className="text-white bg-blue-600 uppercase cursor-pointer flex items-center px-3 rounded py-1"
          >
            {" "}
            <span>
              <MdAdd className="text-2xl" />
            </span>
            <span>Service Bill</span>
          </Link> */}
        </div>
      </div>
      <input
        type="text"
        placeholder="Search"
        className="border ml-12 focus:outline-none h-8 rounded p-1"
        value={searchTerm}
        onChange={(e) => setSearchTerm(e.target.value)}
      />
      <div className="h-[71vh] overflow-auto w-full m-auto px-12 my-5">
        {isLoading ? (
          <div className="w-fll h-screen flex flex-col items-center justify-center">
            <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-gray-900"></div>
          </div>
        ) : filterSearch?.length === 0 ? (
          <p className=" text-xl text-red-500 mt-20 ml-20">
            There are no Product / Model
          </p>
        ) : (
          <TableContainer
            component={Paper}
            // style={{ backgroundColor: "#f0f0f5" }}
            className="border"
          >
            <Table stickyHeader>
              <TableHead className="bg-blue-500">
                <TableRow>
                  <TableCell style={{ backgroundColor: "#f0f0f5" }}>
                    <span className="font-bold">Job No.</span>
                  </TableCell>
                  <TableCell style={{ backgroundColor: "#f0f0f5" }}>
                    <span className="font-bold">Recv Date</span>
                  </TableCell>
                  <TableCell style={{ backgroundColor: "#f0f0f5" }}>
                    <span className="font-bold">Client</span>
                  </TableCell>
                  <TableCell style={{ backgroundColor: "#f0f0f5" }}>
                    <span className="font-bold">Model</span>
                  </TableCell>
                  <TableCell style={{ backgroundColor: "#f0f0f5" }}>
                    <span className="font-bold">Claim</span>
                  </TableCell>
                  <TableCell style={{ backgroundColor: "#f0f0f5" }}>
                    <span className="font-bold">Job</span>
                  </TableCell>
                  <TableCell style={{ backgroundColor: "#f0f0f5" }}>
                    <span className="font-bold">Status</span>
                  </TableCell>
                  <TableCell style={{ backgroundColor: "#f0f0f5" }}>
                    <span className="font-bold ">Action</span>
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {filterSearch
                  ?.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                  ?.map((row, i) => {
                    const passData = {
                      jobId: row?.id,
                      clientId: row?.client_id,
                    };
                    return (
                      <TableRow key={row.id}>
                        <TableCell>{row?.job_no}</TableCell>
                        <TableCell>{formatDate(row?.p_r_date)}</TableCell>
                        <TableCell>{row?.client}</TableCell>
                        <TableCell>{row?.model}</TableCell>

                        <TableCell className="">
                          <div className="flex items-center gap-x-4">
                            <Link
                              to={`/dashboard/product-service/claim-form/${row?.id}`}
                            >
                              <span className=" underline text-blue-600">
                                Claim Form
                              </span>
                            </Link>
                          </div>
                        </TableCell>
                        <TableCell className="">
                          <div className="flex items-center gap-x-4">
                            <Link
                              to={`/dashboard/product-service/delivery-form/${row?.id}`}
                            >
                              <span className=" underline text-blue-600">
                                Delivery Form
                              </span>
                            </Link>
                          </div>
                        </TableCell>
                        <TableCell>{row?.delivery_status}</TableCell>
                        <TableCell className="">
                          <div className="flex items-center gap-x-4">
                            {/* <span onClick={() => handleDelete(row?.id)}>
                              <MdDelete className="text-xl text-red-500 font-bold cursor-pointer" />
                            </span> */}
                            <Link
                              to="/dashboard/product-service/view"
                              state={row}
                            >
                              <span className="border border-blue-600 p-1 rounded text-blue-600">
                                View
                              </span>
                            </Link>
                            <Link
                              to="/dashboard/product-services-bill"
                              state={passData}
                            >
                              <span className="border border-green-600 font-bold p-1 rounded text-green-700">
                                Bill
                              </span>
                            </Link>
                          </div>
                        </TableCell>
                      </TableRow>
                    );
                  })}
              </TableBody>
            </Table>
            <TablePagination
              style={{ backgroundColor: "#f0f0f5" }}
              rowsPerPageOptions={[50, 100, 200]}
              component="div"
              count={filterSearch?.length}
              rowsPerPage={rowsPerPage}
              page={page}
              onPageChange={handleChangePage}
              onRowsPerPageChange={handleChangeRowsPerPage}
            />
          </TableContainer>
        )}
      </div>
    </div>
  );
};

export default ProService;
